import { Link } from "@/lib/router";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";

/** 가입 직후 "메일함을 확인해주세요" 안내. 페이지 이동 대신 모달로 띄워서 가입 화면 맥락을 유지한다. */
export function SignUpSuccessDialog({ open }: { open: boolean }) {
  return (
    <Dialog open={open}>
      <DialogContent showCloseButton={false} className="max-w-sm">
        <DialogHeader>
          <DialogTitle>메일함을 확인해주세요</DialogTitle>
          <DialogDescription>인증 메일을 보냈어요</DialogDescription>
        </DialogHeader>
        <div className="flex flex-col gap-3 text-sm text-muted-foreground">
          <p>메일에 있는 인증 링크를 누르면 가입이 완료되고 바로 시작할 수 있어요.</p>
          <p>메일이 안 보이면 스팸함도 확인해주세요.</p>
        </div>
        <DialogFooter>
          <Link href="/auth/login" className="w-full">
            <Button className="w-full rounded-full">로그인 화면으로</Button>
          </Link>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
